import React, { Component } from 'react'
import { Dialog, DialogContent, DialogTitle, DialogActions, Button, Grid } from '@material-ui/core'
import { connect } from 'react-redux'
import { EditableReactSelect } from '../common/EditableComponents'
import { addLocationMasterProduct } from '../../actions/masterCatalog'

class ModalCreateChildProduct extends Component {
  constructor(props) {
    super(props)
    this.state = {
      shops: [],
    }
  }

  handleShops = (shopList) => {
    this.setState({
      shops: shopList,
    })
  }

  closeModal = () => {
    this.props.handleCloseModalToClone(false)
    this.setState({
      shops: [],
    })
  }

  cloneMasterProduct = async () => {
    const { product, dispatch, handleCloseModalToClone } = this.props
    const { shops = [] } = this.state

    if (shops.length === 0) return

    const newLocations = shops.map((s) => s.value)
    if (newLocations.length > 0) {
      const addLocationReq = {
        masterProductIds: [product.id],
        locations: newLocations,
      }
      await dispatch(addLocationMasterProduct(addLocationReq))
      handleCloseModalToClone(true)
      this.setState({ shops: [] })
    }
  }

  render() {
    const { shops } = this.state
    const { shopReducer, open, product } = this.props
    return (
      <Dialog open={open}>
        <DialogTitle>Cloning: {product.name}</DialogTitle>
        <DialogContent style={{ height: '280px', width: '500px' }}>
          <Grid display="flex" className="form-modal">
            <EditableReactSelect
              multi={true}
              editMode={true}
              material={false}
              value={shops}
              onChange={this.handleShops}
              valueToRender={shops}
              InputLabelProps={{
                shrink: true,
              }}
              options={
                shopReducer.shopsList
                  ? shopReducer.shopsList.values
                    ? shopReducer.shopsList.values
                        .filter((s) => !s.deleted && s.name)
                        .map((shop) => ({
                          value: shop.id,
                          label: shop.name,
                          disabled: !shop.active,
                          clearableValue: true,
                        }))
                    : []
                  : []
              }
            />
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.closeModal} className="button-white-and-red">
            <span className="button-text">Cancel</span>
          </Button>
          <Button onClick={this.cloneMasterProduct} className="button-blue-and-white">
            <span className="button-text">Clone</span>
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export const ModalCreateChildProductLoader = connect(({ dispatch, shopReducer }) => ({
  dispatch,
  shopReducer,
}))(ModalCreateChildProduct)



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/ModalCreateChildProduct.js